export enum ColourMod {
    Primary = 'primary',
    Secondary = 'secondary',
    Success = 'success',
    Warning = 'warning',
    Alert = 'alert',
    Danger = 'danger',

    Text = 'text',
    Selected = 'success active',
}

export enum ColourSolid {
    Primary = 'primary-solid',
    Secondary = 'secondary-solid',
    Success = 'success-solid',
    Warning = 'warning-solid',
    Alert = 'alert-solid',
    Danger = 'danger-solid',
}

export enum Padding {
    ExtraSmall = 'p-xs',
    Small = 'p-sm',
    Medium = 'p-md',
    Large = 'p-lg',
    ExtraLarge = 'p-xl',
    ExtraExtraLarge = 'p-xxl',
}

export enum Margin {
    ExtraSmall = 'm-xs',
    Small = 'm-sm',
    Medium = 'm-md',
    Large = 'm-lg',
    ExtraLarge = 'm-xl',
    ExtraExtraLarge = 'm-xxl',
}

export enum FlexGap {
    ExtraSmall = 'flex-gap-xs',
    Small = 'flex-gap-sm',
    Medium = 'flex-gap-md',
    Large = 'flex-gap-lg',
    ExtraLarge = 'flex-gap-xl',
    ExtraExtraLarge = 'flex-gap-xxl',
}

export enum FlexAlign {
    Start = 'align-start',
    Center = 'align-center',
    End = 'align-end'
}

export enum FlexJustify {
    Start = 'justify-start',
    Between = 'justify-between',
    Center = 'justify-center',
    End = 'justify-end'
}

export enum Placement {
    TopRight = 'block-start-inline-end',
    BottomRight = 'block-end-inline-end',
    BottomLeft = 'block-end-inline-start',
    TopLeft = 'block-start-inline-start',
    Left = 'inline-start',
    Right = 'inline-end'
}